import React from 'react';
import { Flex, HStack, Text } from '@chakra-ui/react';

import colors from '../../../styles/theme/foundation/colors';

function InsurancePolicyRequirements({ booleanProperties, nonBooleanProperties }) {
  return (
    <HStack alignItems="flex-start" mt={3} width="100%">
      <Flex direction="column" width="45%">
        <Text color={colors.greyScale['500']} textStyle="bodyXs500">Required Coverage: </Text>
        {booleanProperties}
      </Flex>
      <Flex direction="column" width="55%">
        {nonBooleanProperties}
      </Flex>
    </HStack>
  );
}

export default InsurancePolicyRequirements;
